import { countryList } from "@/locales/properNouns";
import messages from "./json/pt.json";

export default {
  pl: {
    word: "{n} {word} | {n} {word}s",
  },
  notificationsText: {
    liked: "A {screenName} gostou da sua publicação",
    followed: "{screenName} começou a seguir você",
    subscribed: "{screenName} se inscreveu em você por {price}",
    upgradeSubscription: "{screenName} atualizou a assinatura contigo. Agora o nível de assinatura é {price}",
    soldPost: "{screenName} comprou sua publicação por {price}",
    soldAttachment: "{screenName} comprou seu anexo por {price}",
    soldEvent: "{screenName} reservou seu evento {date} por {price}",
    eventPublished: "Próximo evento por {screenName}!",
    eventStarted: "O evento começou",
    eventCancelled: "{screenName} cancelou o evento",
  },
  ...messages,
  ...countryList,
};
